function MadeWithLove() {
  return <div className="made-with-love">Made with ❤ by NearU!</div>;
}

export default MadeWithLove;
